import { render, staticRenderFns } from "./c_home_menu.vue?vue&type=template&id=a1cd64de&scoped=true&"
import script from "./c_home_menu.vue?vue&type=script&lang=js&"
export * from "./c_home_menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1cd64de",
  null
  
)

export default component.exports